import Vue from 'vue';
import mixins from '../mixins';
import Axios from 'axios';
import { CREATE_ORDER } from '../constants/endpoints';
//import _ from 'lodash'

const defaultState = () => {
  return {
    products: [],
    company: {},
    distribution: {},
    incoterm: '',
    transport: 'sea',
    showCart: false
  }
}

const cart = {
  state: defaultState(),
  namespaced: true,
  mutations: {
    add(state, product) {
      //check min order
      if(product.quantity < product.min_order) {
        Vue.toasted.error('Product quantity must be greater or equal to '+product.min_order);
        return;
      }
      var price = product.price;
      product.subtotal = mixins.methods.round((price.carton_price*product.quantity) ,2);
      product.formatted_subtotal = mixins.methods.round((price.carton_price*product.quantity) ,2);
      state.products.push(product);
      state.products.sort(function(a, b) {
        return a.is_flash - b.is_flash;
      });
      Vue.toasted.success('Product added');
    },
    update(state, { product, addUp, failedUpdate }) {

      const existing = state.products.find(x => x.id === product.id);

      if(failedUpdate === 'min') {
        Vue.toasted.error('Product quantity must be greater or equal to '+product.quantity)
        return
      }

      const quantity = addUp === true ? existing.quantity+product.quantity : product.quantity 
      var price = existing.price;
      existing.quantity = quantity;
      existing.subtotal = mixins.methods.round((price.carton_price*quantity), 2)
      existing.formatted_subtotal = mixins.methods.round((price.carton_price*quantity), 2)

      Vue.toasted.success('Quantity updated')
    },
    remove(state, id) {
      state.products = state.products.filter( function(val) {
        return val.id != id
      })
    },
    clearProducts(state) {
      state.products = []
    },
    clear(state, clearOnlyItems = false) {
      // Merge rather than replace so we don't lose observers
      // https://github.com/vuejs/vuex/issues/1118
      if(clearOnlyItems) {
        state.products = []
        return
      }
      Object.assign(state, defaultState())
    },
    company(state, company) {
      state.company = company
    },
    setDistribution(state, dist) {
      state.distribution = dist
    },
    setIncoterm(state, incoterm) {
      state.incoterm = incoterm
    },
    setTransport(state, transport) {
      state.transport = transport
    },
    cartToggle(state) {
      state.showCart = !state.showCart
    }
  },
  actions: {
    setIncoterm({commit}, incoterm) {
      commit('setIncoterm', incoterm)
    },
    setTransport({commit}, transport) {
      commit('setTransport', transport)
    },
    addToCart({state, commit, dispatch}, product) {
      //check if exist already in cart
      const existing = state.products.find(x => x.id === product.id)
      if(existing) {
        commit('update', { product, addUp: true })
      } else {
        commit('add', product)
      }
      if(state.incoterm === 'REVOOLOOP') {
        dispatch('getDistribution')
      }
    },
    removeFromCart({commit}, id) {
      Vue.toasted.success('Product deleted successfully')
      commit('remove', id)
    },
    clearCart({commit}) {
      commit('clear')
    },
    clearCartItems({commit}) {
      commit('clear', true)
    },
    updateQuantity({state, commit, dispatch}, updates) {
      return new Promise((resolve) => {
        const item = state.products.find(i => i.id === updates.id)

        if(updates.quantity == 0 || updates.quantity == '') {
          commit('remove', updates.id)
        } else if(updates.quantity < item.min_order) {
          commit('update', { product: { id: updates.id, quantity: item.min_order }, failedUpdate: 'min' })
          resolve(item.quantity)
        } else {
          commit('update', { product: { id: updates.id, quantity: updates.quantity }})
          if(state.incoterm === 'REVOOLOOP') {
            dispatch('getDistribution')
          }
        }
      })
    },
    setCompany({commit}, company) {
      commit('company', company)
    },
    confirmOrder({state, getters, rootGetters}, data) {
      //pass correct type
      var is_quotation = 0;
      if(data.type === 'quotation') {
        is_quotation = 1;
      }

      /*console.log(JSON.stringify({
        quotation: is_quotation,
        reference: '',
        customer_id: getters.company.id,
        currency: rootGetters.getCurrency,
        products: state.products,
        incoterm: state.incoterm
      }));*/

      return new Promise((resolve, reject) => {
        Axios.post(mixins.methods.buildEndpoint(CREATE_ORDER), {
          quotation: is_quotation,
          reference: data.reference,
          customer_id: getters.company.id,
          currency: rootGetters.getCurrency,
          products: state.products,
          incoterm: state.incoterm,
          notify_client: data.notify
        }).then(resp => {
          if(resp.data.result == true) {
            resolve(resp)
          } else {
            reject(resp)
          }
        }).catch((error) => {
          reject(error)
        })
      })
    },
    getDistribution({commit, getters, rootGetters}) {
      return new Promise((resolve, reject) => {
        Axios.get(mixins.methods.endpoint('distribution/get'), {
          params: {
            origin_zone: getters.origin_zone,
            destination_zone: getters.destination_zone,
            cbm: getters.cbm,
            currency: rootGetters.getCurrency
          }
        }).then(dist => {
          commit('setDistribution', dist.data.data)
          resolve()
        }).catch(() => {
          reject()
        })
      })
    }
  },
  getters: {
    products: state => state.products,
    count: state => state.products.length,
    company: state => state.company,
    subtotal: state => {
      const sum = state.products.map(function(p) {
        return +p.subtotal
      })
      return sum.reduce((a, b) => a + b, 0)
    },
    cbm: state => {
      const sum = state.products.map(function(p) {
        return p.cbm_per_carton*p.quantity
      })
      return sum.reduce((a, b) => a + b, 0)
    },
    weight: state => {
      const sum = state.products.map(function(p) {
        return p.weight_per_carton*p.quantity
      })
      return sum.reduce((a, b) => a + b, 0)
    },
    origin_zone: state => state.company.warehouse.zone.id,
    destination_zone: state => state.company.zone.id,
    distribution: state => state.distribution,
    total: (state, getters) => {
      var total = getters.subtotal
      if(getters.incoterm === 'REVOOLOOP') {
        total += getters.distribution.cost_total
      }
      return total
    },
    incoterm: (state) => state.incoterm,
    transport: (state) => state.transport,
    showCart: (state) => state.showCart
  }
}

export default cart